
const publicPath = '/modules/cv_photo_product_gallery/views';
module.exports = {
    port: 3008,
    publicPath: publicPath,
    serverAddress: '127.0.0.1',
    siteURL: 'dev.saway.pl',
    httpProtocol: 'https',

    entry: {
        '/css/get-the-look': [
            './scss/get-the-look.scss',
        ],
        '/css/get-the-look-widget': [
            './scss/get-the-look-widget.scss',
        ],
        '/js/get-the-look': [
            './get-the-look.js',
        ],
    },

    getDevServerUrl : function() {
        return this.httpProtocol + '://' + this.serverAddress + ':' + this.port
    }
}
